import React from 'react'

const aSec = 1000
const aMin = aSec*60
const anHour = aMin*60
const aDay = anHour*24
//const aWeek = aDay*7
const aMonth = aDay*30.44 // average day count in a month
const aYear = aMonth*12

export default class Timeago extends React.Component {
  state={
    toggle: false,
  }
  componentDidMount() {
    this.tick()
  }
  componentWillUnmount() {
    const {timer} = this.state
    if (typeof(timer)==='number') {
      clearTimeout(timer)
    }
  }
  tick=()=>{
    this.setState({now:Date.now()},()=>{
      const timeout = this.calcTimeout()
      if (timeout>0) {
        const timer = setTimeout(this.tick,timeout)
        this.setState({timer})
      }
    })
  }
  calcTimeout() {
    const {value} = this.props
    const {now} = this.state
    if (value instanceof Date) {
      const ms = value.getTime()
      const diff = Math.abs(now-ms)
      if (diff>0) {
        if (diff<aMin) return aSec
        if (diff<anHour) return aMin
        if (diff<aDay) return anHour
        if (diff<aMonth) return aDay
        if (diff<aYear) return aMonth
      }
    }
    return aYear
  }
  onToggle=e=>{
    e.preventDefault()
    const {toggle} = this.state
    this.setState({toggle:!toggle})
  }
  render() {
    const {toggle} = this.state
    const {t,value,className} = this.props

    if (toggle) {
      if (value instanceof Date) {
        const s = value.toISOString().split('T')[0]
        return (
          <div className={className} onClick={this.onToggle}>{s}</div>
        )
      }
    }

    if (value instanceof Date) {
      const {now} = this.state
      const diff = now-value.getTime()
      if (diff>=0) {
        if (diff<aSec) {
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:Just now')}</div>
        }
        if (diff<aMin) {
          const n = parseInt(diff/aSec)
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n seconds ago',{n})}</div>
        }
        if (diff<anHour) {
          const n = parseInt(diff/aMin)
          if (n===1) {
            return <div className={className||''} onClick={this.onToggle}>{t('datetime:A minute ago')}</div>
          }
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n minutes ago',{n})}</div>
        }
        if (diff<aDay) {
          const n = parseInt(diff/anHour)
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n hours ago',{n})}</div>
        }
        if (diff<aMonth) {
          const n = parseInt(diff/aDay)
          if (n===1) {
            return <div className={className||''} onClick={this.onToggle}>{t('datetime:Yesterday')}</div>
          }
          if (n%7===0) {
            if (n/7===1) {
              return <div className={className||''} onClick={this.onToggle}>{t('datetime:Last week')}</div>
            }
            return <div className={className||''} onClick={this.onToggle}>{t('datetime:n weeks ago',{n:n/7})}</div>
          }
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n days ago',{n})}</div>
        }
        if (diff<aYear) {
          const n = parseInt(diff/aMonth)
          if (n===1) {
            return <div className={className||''} onClick={this.onToggle}>{t('datetime:Last month')}</div>
          }
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n months ago',{n})}</div>
        }
        const n = parseInt(diff/aYear)
        if (n===1) {
          return (
            <div className={className||''} onClick={this.onToggle}>{t('datetime:Last year')}</div>
          )
        }
        return (
          <div className={className||''} onClick={this.onToggle}>{t('datetime:n years ago',{n})}</div>
        )
      }

      const aDiff = diff*-1
      if (aDiff<aSec*10) {
        const n = parseInt(Math.ceil(aDiff/aSec))
        if (n===1) {
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more second',{n})}</div>
        }
        return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more seconds',{n})}</div>
      }
      if (aDiff<aMin) {
        const n = parseInt(Math.ceil(aDiff/aSec))
        return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more seconds',{n})}</div>
      }
      if (aDiff<anHour) {
        const n = parseInt(Math.ceil(aDiff/aMin))
        if (n===1) {
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more minute',{n})}</div>
        }
        return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more minutes',{n})}</div>
      }
      if (aDiff<aDay) {
        const n = parseInt(Math.ceil(aDiff/anHour))
        if (n===1) {
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more hour',{n})}</div>
        }
        return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more hours',{n})}</div>
      }
      if (aDiff<aMonth) {
        const n = parseInt(Math.ceil(aDiff/aDay))
        if (n===1) {
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:Tomorrow')}</div>
        }
        if (n%7===0) {
          if (n/7===1) {
            return <div className={className||''} onClick={this.onToggle}>{t('datetime:Next week')}</div>
          }
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more weeks',{n:n/7})}</div>
        }
        return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more days',{n})}</div>
      }
      if (aDiff<aYear) {
        const n = parseInt(Math.ceil(aDiff/aMonth))
        if (n===1) {
          return <div className={className||''} onClick={this.onToggle}>{t('datetime:Next month')}</div>
        }
        return <div className={className||''} onClick={this.onToggle}>{t('datetime:n more months',{n})}</div>
      }
      const n = parseInt(Math.ceil(aDiff/aYear))
      if (n===1) {
        return (
          <div className={className||''} onClick={this.onToggle}>{t('datetime:Next year')}</div>
        )
      }

      return (
        <div className={className||''} onClick={this.onToggle}>{t('datetime:n more years',{n})}</div>
      )
    }
    return null
  }
}
